import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cookie from 'react-cookies';
import { connect } from 'react-redux';
import { ToastsContainer, ToastsStore } from 'react-toasts';
import { useNavigate } from 'react-router-dom';
import Api from '../../../util/api';
import AuthApi from '../../../util/authApi';
import scss from './profile-user.module.scss';
import profImg from '../../../../src/assets/images/user-profile.jpg';

const ProfileHeader = ({ loadProfileImage }) => {
    const [userDetails, setUserDetails] = useState(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const token = cookie.load('token');
        if (token) {
            getUserData();
        } else {
            window.location.href = `${window.location.origin}/login`;
        }
        global.document.addEventListener('click', handleClick, false);

        return () => {
            global.document.removeEventListener('click', handleClick, false);
        };
    }, []);

    useEffect(() => {
        if (loadProfileImage) {
            getUserData();
        }
    }, [loadProfileImage]);

    const handleClick = event => {
        if (event.target.matches('.drpdwnMenu')) return;
        if (!event.target.matches('.open-menu')) {
            setShowDropdown(false);
        }
    };

    const getUserData = async () => {
        const endPoint = `${Api.profileUrl}`;
        const { data, message } = await AuthApi.getDataFromServer(endPoint);
        if (data) {
            setUserDetails(data.data);
        } else {
            await cookie.remove('token', { path: '/' });
            cookie.remove('userId', { path: '/' });
            cookie.remove('roleId', { path: '/' });
            window.location.href = `${window.location.origin}/login`;
            ToastsStore.error(message);
        }
    };

    const logOut = async () => {
        const confirmMsg = window.confirm('Are you sure you want to log out?');
        if (!confirmMsg) return;

        const { data, message } = await AuthApi.getDataFromServer(`${Api.logoutUrl}`);
        if (data) {
            cookie.remove('token', { path: '/' });
            cookie.remove('userId', { path: '/' });
            cookie.remove('roleId', { path: '/' });
            navigate('/login');
        } else {
            ToastsStore.error(message);
        }
    };

    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };

    const userId = cookie.load('userId');

    return (
        <div>
            <div className={scss.profileView}>
                <a className={`${showDropdown ? scss['open-menu'] : ''} drpdwnMenu`} onClick={toggleDropdown}>
                    <strong className={`${scss.profileImg} drpdwnMenu`}>
                        <img
                            src={
                                userDetails && userDetails.asset_sizes
                                    ? `${Api.IMAGE_URL}${userDetails.asset_sizes}`
                                    : profImg
                            }
                            className={`${scss.image} drpdwnMenu`}
                            alt="Profile"
                        />
                    </strong>
                    <span className={`${scss.profileText} drpdwnMenu`}>{userDetails && userDetails.first_name}</span>
                </a>
                <ToastsContainer store={ToastsStore} />
                {showDropdown && (
                    <div className={scss.dropdown}>
                        <ul>
                            <li>
                                <a href={`/admin-users/view/${userId}`}>My Profile</a>
                            </li>
                            <li>
                                <a href="/change-password">Change Password</a>
                            </li>
                            <li>
                                <a onClick={logOut}>Log Out</a>
                            </li>
                        </ul>
                    </div>
                )}
            </div>
        </div>
    );
};

ProfileHeader.propTypes = {
    loadProfileImage: PropTypes.bool,
};

const mapStateToProps = state => ({
    //loadProfileImage: state.userProfile.loadProfileImage
});

const mapDispatchToProps = dispatch => ({
    // updateProfile: (flag) => {
    //   dispatch(updateProfileImage(flag));
    // }
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileHeader);
